module.exports = __webpack_public_path__ + "static/media/techb1.77f08333.jpg";